import { Component, Input, OnInit } from '@angular/core';
import { AgentDto, TicketDto, TicketModeEnum, WorkflowDto } from '../../../../../../service/dto';
import { HttpTicketService } from '../../../../../../service/http-ticket.service';
import { Router } from '@angular/router';
import { TicketHistoryComponent } from '../../../../../tickets/tickets-form/components/ticket-history/ticket-history.component';
import { NzModalService } from 'ng-zorro-antd/modal';

class ModeWrapper {
	mode!: TicketModeEnum;
	workflows!: WorkflowWrapper[];
}
class WorkflowWrapper {
	workflow!: WorkflowDto;
	tickets!: TicketDto[];
}
@Component({
	selector: 'app-agent-view-tickets',
	standalone: false,
	templateUrl: './agent-view-tickets.component.html',
	styleUrl: './agent-view-tickets.component.scss'
})
export class AgentViewClaimsComponent {
	_agent!: AgentDto;
	modes: ModeWrapper[] = [];
	loading = false;
	error: string | null = null;

	constructor(private ticketService: HttpTicketService, private router: Router, private modalService: NzModalService) {

	}
	@Input()
	set agent(input: AgentDto) {
		this._agent = input;
		this.loading = true;
		this.error = null;

		this.ticketService.getAgentsTickets(this._agent).subscribe({
			next: result => {
				this.init(result);
				this.loading = false;
			},
			error: err => {
				this.error = 'Unable to load tickets.';
				this.loading = false;
			}
		});
	}
	init(tickets: TicketDto[]): void {
		// Group by mode
		const modesMap = new Map<TicketModeEnum, Map<number, TicketDto[]>>();

		for (const t of tickets) {
			if (!modesMap.has(t.ticketMode!)) {
				modesMap.set(t.ticketMode!, new Map());
			}
			const workflowsMap = modesMap.get(t.ticketMode!)!;

			if (!workflowsMap.has(t.workflowId)) {
				workflowsMap.set(t.workflowId, []);
			}
			workflowsMap.get(t.workflowId)!.push(t);
		}

		// Convert to ModeWrapper[]
		this.modes = Array.from(modesMap.entries()).map(([mode, workflowsMap]) => {
			const workflowWrappers: WorkflowWrapper[] = Array.from(workflowsMap.entries()).map(([workflowId, tickets]) => {
				// All tickets in this group share the same workflow metadata
				const workflow = tickets[0].workflowLabel
					? {
						id: workflowId,
						label: tickets[0].workflowLabel,
						description: tickets[0].workflowDescription
					} as WorkflowDto
					: {} as WorkflowDto;

				return {
					workflow,
					tickets
				};
			});

			return {
				mode,
				workflows: workflowWrappers
			};
		});
	}


	openTicket(input: TicketDto) {
		this.router.navigate(['/ticket', input.ticketMode, input.id]);
	}
	showTicketHistory(ticket: TicketDto) {
		const modal = this.modalService.create({
			nzTitle: 'Tickets History',
			nzContent: TicketHistoryComponent,
			nzWidth: '80%',
			nzFooter: null
		});
		modal.componentInstance!.ticket = ticket!;
	}
	getSlaClass(ticket: TicketDto): 'success' | 'info' | 'warning' | 'error' {
		if (ticket.slaLevelGlobal == 'Good') {
			return 'success';
		}
		if (ticket.slaLevelGlobal == 'Warning') {
			return 'warning';
		}
		return 'error';
	}
}
